import React, { PureComponent } from 'react';
import injectSheet, {withTheme} from 'react-jss'
import cn from 'classnames'
import ResponsiveImage from '../Widgets/ResponsiveImage'
import Section from "../Widgets/Section"
import SectionTitle from "../Widgets/SectionTitle"
import flow from 'lodash/flow'
import ShopTheLookCarousel from '../ShopThLook/ShopTheLookCarousel'
import CategoryLabel from '../Widgets/CategoryLabel'

class TopPicksSlice extends PureComponent {

    next = () => {
        if(this.flkty)
            this.flkty.next();
    }

    previous = () => {
        if(this.flkty)
            this.flkty.previous();
    }

    setFlktyRef = (ref) => {this.flkty = ref}

    render() {
        const {classes, theme, className, id, slice} = this.props;

        return <section className={cn(classes.root, className)}>
                <SectionTitle text={slice.title.text} color={theme.colors.topPicks} link={slice.link} dataCy='topPicksTitle'/>
                <Section className={classes.innerSection} dataCy='topPicksContent'>
                    <div className={classes.innerContainer}>
                        <div className={classes.products} data-cy="topPicksProductsContainer">
                            <div className={classes.toolbar}>
                                <div className={classes.categoryContainer} data-cy="topPicksProductsTitle">
                                    <CategoryLabel color={theme.colors.topPicks} category={slice.title.text} />
                                    <span className={classes.divider}>|</span>
                                    <span className={classes.category}>{slice.category}</span>
                                </div>
                            </div>
                            <div className={classes.carouselContainer} data-cy="topPicksProductsCarousel">
                                <ShopTheLookCarousel id={`${id}-top-picks`} classNames={classes} shopItems={slice.shopItems} size="large" showTitle={false} showNextPrevButtons={true} flktyRef={this.setFlktyRef} />
                            </div>
                        </div>
                        <ResponsiveImage key='image' images={slice.image} link={slice.link} className={classes.image} />
                    </div>
                </Section>
            </section>
    }
}

export default flow([
    withTheme,
    injectSheet(theme => ({
        root: {
            backgroundColor: theme.colors.info,
            paddingTop: theme.spacing.large,
        },
        innerContainer: {
            overflow: 'hidden',
            backgroundColor: theme.colors.white,
            borderRadius: 2.5,
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.14)',
            display: 'flex',
            flexDirection: 'column-reverse',
            maxWidth: 360,
            margin: 'auto',
            [theme.breakpoint('tablet')]: {
                maxWidth: 'none',
                flexDirection: 'row-reverse',
            }
        },
        image: {
            maxWidth: 360,
            flexGrow: 0,
            zIndex: theme.zIndex.carousel + 1
        },
        products: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            paddingBottom: '1rem'
        },
        toolbar: {
            flexGrow: 0,
            margin: [theme.spacing.small, theme.spacing.small, 0],
            position: 'relative'
        },
        categoryContainer: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 0,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            lineHeight: '36px'
        },
        category: {
            whiteSpace: 'nowrap',
            display: "flex",
            alignItems: "center",
            color: theme.colors.assent,
            fontSize: 12,
            fontWeight: theme.font.info.fontWeight,
            lineHeight: theme.font.info.lineHeight,
        },
        divider: {
            color: theme.colors.assent,
            margin: [0, theme.spacing.tiny],
        },
        carouselContainer: {
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            margin: [0, theme.spacing.small]
        },
        itemsContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            width: '100%',
            overflowX: 'scroll',
            [theme.breakpoint('tablet')]: {
                justifyContent: 'center'
            }
        },
        item: {
            position: 'relative',
            fontSize: 12,
            lineHeight: '16px',
            textAlign: 'left',
            width: 150,
            margin: '0 15px 30px 0',
            '&:last-child': {
                margin: '0 0 30px 0'
            },
            [theme.breakpoint('tablet')]: {
                width: 200
            }
        },
        product: {
            lineHeight: '24px',
            letterSpacing: '0.3px',
            fontSize: 14,
            color: '#B0B0B0',
            [theme.breakpoint('tablet')]: {
                fontSize: 15
            }
        },
        brand: {
            fontWeight: 'bold',
            letterSpacing: '0.3px',
            fontSize: 14,
            lineHeight: '24px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'initial',
            [theme.breakpoint('tablet')]: {
                fontSize: 14
            }
        },
        price: {
            fontSize: 14,
            color: theme.colors.black,
            lineHeight: '24px',
            letterSpacing: '0.3px',
            [theme.breakpoint('tablet')]: {
                fontSize: 14
            }
        },
        itemImageFrame: {
            display: 'block',
            background: '#F3F3F7',
            height: 193,
            width: '100%',
            marginBottom: 15,
            [theme.breakpoint('tablet')]: {
                height: 269
            }
        },
        itemImage: {
            backgroundColor: theme.colors.assent,
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            '&:hover': {
                filter: 'brightness(100%)'
            }
        }
    }))
])(TopPicksSlice);



// WEBPACK FOOTER //
// ./src/components/LandingPage/TopPicksSlice.js